import { useState } from 'react';
import { ReviewCard } from "@components/organism";
import { useReviewUserAccount } from "./useReviewUserAccount";
import { Checkboxs } from '@components/molecules';
import { zafClient } from '@services/Zendesk';

export function ReviewUserAccount() {
    const { 
        selectedUser, 
        info, 
        navigate, 
        handleSave,
        selectedRole ,
        loading,
    } = useReviewUserAccount();

    const [linkToAccount, setLinkToAccount] = useState(true);

    if (!selectedUser) {
        return <div className="p-4">Nenhum usuário selecionado para revisão.</div>;
    }

    const isNewUser = !selectedUser.id;

    return (
        <div>
            <ReviewCard
                title="• Criar conta"
                subtitle="Revise os dados da conta:"
                info={info}
                onPrimaryAction={() => handleSave(linkToAccount)}
                onSecondaryAction={() => navigate(`/add-account`)}
                primaryActionLabel={`${loading ? 'Salvando' : 'Salvar conta'}`}
                headerLabel="Cliente"
                disabled={loading}
                createNewAccount={isNewUser}
                onSeeUser={() => {
                    if (!selectedUser?.id) return;

                    zafClient.invoke('routeTo', 'user', selectedUser.id);
                }}
            />

            {isNewUser && (
                <div className="mt-4 ml-4">
                    <Checkboxs items={{
                        title: `Vincular usuário à conta ${selectedRole}`,
                        checked: linkToAccount,
                        onChange: (checked) => setLinkToAccount(checked),
                    }} />
                </div>
            )}
        </div>
    );
}